import Programs from '../components/program_components/index'

const Program = () => {
  return (
    <div className="">
      <div>{/* <Navbar />       */}</div>
      <div>
        <Programs />
      </div>
    </div>
  )
}

export default Program
